/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".navbar-ontop[_ngcontent-%COMP%]{z-index:10000;opacity:1}.navbar-brand[_ngcontent-%COMP%]{padding-bottom:0;padding-top:0}.fabber-logo[_ngcontent-%COMP%]{height:40px}.fabber-name[_ngcontent-%COMP%]{font-family:nasalization}.nav-link[_ngcontent-%COMP%]{cursor:pointer}"];
export { styles as styles };
